import styled from "styled-components";

export const MeteringBarContainer = styled.div`
    display: flex;
    height: 10px;
    width: 100%;
    background-color: #f5f5f5;
`;
